import React from 'react'
import { Link } from 'react-router-dom'
import checkForAttributeMapping from '../functions/checkForAttributeMapping'

const SubMenuItem = ({ index, id, activeClass, url, target, title, menu_attribute, isFilter, onToggleNavigation = () => {}, translation }) => {
    let name = title

    if(isFilter) {
        name = checkForAttributeMapping(title, translation)
    }

    return (
        <li key={index} id={"sub-menu-item-" + id } className={"sub-menu-item cursor-pointer text-light " + menu_attribute + activeClass}>
            {isFilter ? (
                <Link to={{search: url}} onClick={() => onToggleNavigation()}>{name}</Link>
            ) : target ? (
                <a href={url} onClick={() => onToggleNavigation()} target={target}>{name}</a>
            ) : (
                <a href={url} onClick={() => onToggleNavigation()}>{name}</a>    
            )
            }
        </li>
    )
}

export default SubMenuItem